const img = require('./materiaPrima.png');
const img2 = require('./Neutralizante.jpeg');
const img3 = require('./espumaNylon.png');

export const imgs = {
  materiaPrima: img,
  neutralizante: img2,
  espumaNylon: img3,
};
